var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCallinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Call_inline_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m5.479 8.671 1.836-1.837a1 1 0 0 0 .083-1.32l-3.17-4.077L2.734 2.93C1.087 4.578.812 7.11 2.109 8.98c1.655 2.383 3.815 5.28 5.748 7.212 1.933 1.933 4.83 4.093 7.212 5.748 1.87 1.297 4.402 1.022 6.05-.626l1.493-1.492-4.076-3.17a1 1 0 0 0-1.321.082l-1.837 1.836-.694-.521c-1.667-1.254-3.371-2.643-4.706-3.978C8.643 12.736 7.254 11.032 6 9.365l-.521-.694Zm1.32.093 1.223-1.223A2 2 0 0 0 8.187 4.9L5.017.823A1 1 0 0 0 3.52.73L2.027 2.223C.057 4.193-.3 7.26 1.287 9.55c1.66 2.39 3.862 5.35 5.862 7.35s4.96 4.202 7.35 5.861c2.289 1.589 5.357 1.23 7.327-.74l1.493-1.492a1 1 0 0 0-.093-1.497l-4.076-3.17a2 2 0 0 0-2.642.165l-1.223 1.222c-1.652-1.241-3.313-2.598-4.6-3.885-1.287-1.287-2.644-2.949-3.885-4.6Z",
  fill: "#252829"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Call_inline_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgCallinline;